// region Helper Functions
import type Community from '@models/Community'
import type CommunityMember from '@models/CommunityMember'
import type Profile from '@models/Profile'

export function getServerSideData(): ServerData | null {
  const bootstrap = document.getElementById('bootstrap')
  if (!bootstrap || !bootstrap.textContent) return null
  return JSON.parse(bootstrap.textContent)
}

export function getAssetManifest(): Record<string, string> | null {
  const assetManifest = document.getElementById('asset-manifest')
  if (!assetManifest || !assetManifest.textContent) return null

  return JSON.parse(assetManifest.textContent)
}

export function getCsrfToken(): string {
  const elem = document.getElementsByName('csrf-token')[0]
  return elem?.getAttribute('content') ?? ''
}
// endregion Helper Functions

// region Types
export type ServerData = {
  instrument_prefix: string
  login: SessionType
  client_settings: ClientSettings
  assetPath: string
  locale: string
  manifest_url: string
  page_props?: any
  application_version: string
  stripePublicKey: string
}

export type SessionUser = {
  avatar_uri: string
  can_create_site: boolean
  username: string
  sites_enabled: boolean
  premium_member: boolean
  has_premium_features: boolean
  has_active_learn_subscription: boolean
  has_active_subscription: boolean
  has_active_trial_subscription: boolean
  has_expired_premium_trial: boolean
  has_lifetime_subscription: boolean
  has_marketplace_sales: boolean
  has_payout_destination: boolean
  has_seller_account: boolean
  effective_admin: boolean
  external_id: string
  profile: Profile
}

// TODO: Move into own Group.ts file?
export type Group = {
  id: number
  is_community_group: boolean
  name: string
}

export type UserGroups = {
  groups: Group[]
  remaining: number
}

export type VisitedScore = {
  title: string
  external_id: string
}

export type SessionType = {
  current_user: SessionUser | null
  community: Community
  community_member: CommunityMember | null
  locale: string
  user_groups: UserGroups
  showSellerFeatures: boolean
  visited_scores?: VisitedScore[]
  is_impersonating: boolean
}

export type ClientSettings = { [key: string]: any }
// endregion Types
